//character.ts — an AI character the wearer becomes in character mode, and how to phrase it to Lucy

export interface Character {
	readonly id: string
	readonly name: string
	//What is visible in the reference: Decart matches the reference more closely the more it is described.
	readonly description: string
	readonly imageURL: string | null
	//Avatar app only: the admin's exact prompt, sent as written instead of the template.
	readonly prompt?: string
}

//Decart's server-side enhancement rewrites the prompt: right for an empty description, wrong for
//a careful one, where a paraphrase can drop exactly the details that hold the likeness. Same idea
//as Shopify garments, where a merchant's own description is sent as written.
export const enhanceCharacter = (character: Character): boolean => character.description.trim() === ''

//Decart's documented character-swap template.
export const CHARACTER_TEMPLATE = 'Substitute the character in the video with'

export const characterPrompt = (character: Character): string =>
	character.prompt?.trim() ||
	`${CHARACTER_TEMPLATE} ${character.description.trim() || 'the character in the reference image'}.`
